import { gql } from "generated-graphql";

export const PROCESSED_MANIFEST_CORRECTION_STATS_QUERY = gql(`
  query ProcessedManifestCorrectionStats($tenantId: ID!, $shippedYear: Int!) {
    processedManifestCorrectionStats(tenantId: $tenantId, shippedYear: $shippedYear) {
      onTime
      late
      overdue
      inWindow
    }
  }
`);

export const PROCESSED_MANIFEST_CORRECTION_STATS_BY_VENDOR_QUERY = gql(`
  query ProcessedManifestCorrectionStatsByVendor($tenantId: ID!, $shippedYear: Int!) {
    processedManifestCorrectionStatsByVendor(tenantId: $tenantId, shippedYear: $shippedYear) {
      vendor
      onTime
      late
      overdue
      inWindow
    }
  }
`);
